import { Link } from 'gatsby';
import React from 'react';
import AccordionIcon from './Icons/AccordionIcon';

const AccordionItem = ({ hiddenContent, toggle, visibleContent, index, datePosted, organization, slug, showContent }) => {

  return (
    <div className="accordion-item">
      <div className="content-wrapper">
        <div className="accordion-item__tags">
          <span>{datePosted}</span>&nbsp;&nbsp;|&nbsp;&nbsp;<span>{organization}</span>
        </div>
        <div className="accordion-item__header" id={`heading${index}`}>
          <button 
            onClick={ toggle } 
            className={`accordion-item__button ${showContent ? '' : 'collapsed'}`} 
            type="button" 
            data-bs-toggle="collapse" 
            data-bs-target={`#collapse${index}`} 
            aria-expanded={ showContent } 
            aria-controls={`#collapse${index}`}
            >
            <div className="button-item__content" dangerouslySetInnerHTML={{__html: visibleContent}}/>
          </button>
        </div>

        <div  
          id={`collapse${index}`} 
          className={`accordion-collapse collapse ${ showContent ? 'show' : '' }`} 
          aria-labelledby={`#heading${index}`} 
          data-bs-parent="#accordion-faqs"
        >
          <div className="accordion-item__body" dangerouslySetInnerHTML={{__html: hiddenContent }} />
          <div className="accordion-item__link">
            <Link to={`/${slug}`} className="btn btn--accordion">
                Read more and apply
            </Link>
          </div>
        </div>
      </div>

      <div className="icon-wrapper" onClick={ toggle } >
        <AccordionIcon state={showContent} />
      </div>

    </div> 
  )
}

export default AccordionItem;